import { render, staticRenderFns } from "./RobotLoader.vue?vue&type=template&id=10474f19&"
import script from "./RobotLoader.vue?vue&type=script&lang=js&"
export * from "./RobotLoader.vue?vue&type=script&lang=js&"
import style0 from "./RobotLoader.vue?vue&type=style&index=0&id=10474f19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports